var exports = {
  "i": "xaee3c4fa--ef6e25--wrapper",
};

module.exports = exports;
